import { railLines, railStatuses } from '@/bundles/GroupFilters/consts';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';

export const getRailFiltersConfigByType = (type: string): IFilterConfigItem[] => [
  {
    title: 'Rail Status',
    name: `${type}_rail_status`, // NEW
    items: railStatuses,
    type: FilterTypeEnum.autocomplete_multiple_select,
    category: FilterCategoryEnum.rail,
  },
  {
    title: 'Total # of Spots',
    name: `${type}_rail_spot_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.rail,
  },
  {
    title: '# of External Spots',
    name: `${type}_rail_external_spot_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.rail,
  },
  {
    title: '# of Internal Spots',
    name: `${type}_rail_internal_spot_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.rail,
  },
  {
    title: 'Rail Line(s)',
    name: `${type}_rail_line`, // NEW
    items: railLines,
    type: FilterTypeEnum.autocomplete_multiple_select,
    category: FilterCategoryEnum.rail,
  },
];
